import React from 'react';

const about_us = (props) => {
    return (
        <div className="row justify-content-center flex-column">
              <div className="col-md-6 col-lg-6 aboutUs">
                <p className="header">ABOUT US</p>
              </div>
              <div className="col-md-6 col-lg-6 about">
                <br />
                <p>{props.about_text}</p>
              </div>
              <h4 className="bottom">RUGBY · FOOTBALL · BASKETBALL</h4>
            </div>
    );
};

export default about_us;